import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DataManagerService } from 'src/app/services/DataManager/data-manager.service';
import { BaseComponent } from 'src/app/shared/abstract/base.component';
import { AppConstants } from 'src/app/shared/constants/app-constants';

@Component({
  selector: 'app-add-expense-account-dialog',
  templateUrl: './add-expense-account-dialog.component.html',
  styleUrls: ['./add-expense-account-dialog.component.css'],
})
export class AddExpenseAccountDialogComponent
  extends BaseComponent
  implements OnInit
{
  public expenseAccountForm: FormGroup;
  public loged_user = JSON.parse(localStorage.getItem('user') || 'null');
  public expenseAccountUrl: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    dataManagerService: DataManagerService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<AddExpenseAccountDialogComponent>,
  ) {
    super();
    this.service = dataManagerService;
    this.expenseAccountUrl =
      AppConstants.BASE_URL + AppConstants.ADDEXPENSEACCOUNT_URL;
    if (dialogData) {
      this.headings = 'Update Expense Account';
      this.buttonText = 'Update';
    } else {
      this.headings = 'Create Expense Account';
      this.buttonText = 'Save';
    }
  }
  ngOnInit(): void {
    this.setdonationTypeForm();
  }
  get expenseAccountFormControl() {
    return this.expenseAccountForm.controls;
  }
  setdonationTypeForm() {
    this.expenseAccountForm = this.formBuilder.group({
      account_number: [
        this.dialogData && this.dialogData.data.account_number
          ? this.dialogData.data.account_number
          : '',
        [Validators.required],
      ],
    });
  }

  onSubmit() {
    if (this.dialogRef.getState() == 0) {
      this.submitted = true;
      if (this.expenseAccountForm.invalid) {
        return;
      } else {
        this.loadFlag2 = true;
        if (this.dialogData) {
          this.expenseAccountForm.value.id = this.dialogData.data.id;
        }
        this.service
          .create(this.expenseAccountUrl, this.expenseAccountForm.value)
          .subscribe({
            next: (res: any) => {
              if (res['status'] == 'success') {
                this.loadFlag2 = false;
                this.dialogRef.close(true);
                this.service.showSnackBar(res.message, 'ok', 3000);
              } else {
                this.loadFlag2 = false;
                this.topErrorMessage = res.message;
                this.keys = Object.keys(this.topErrorMessage);
                this.keys1 = Object.values(this.topErrorMessage);
                let i;
                let j;
                const name = ['cat_name'];
                for (i = 0; i < this.keys.length; i++) {
                  for (j = 0; j < name.length; j++) {
                    if (this.keys[i].match(name[j])) {
                      const documents = document.getElementById(name[j]);
                      if (documents) {
                        documents.style.borderColor = '#a94442';
                        documents.style.display = 'block';
                      }
                    }
                  }
                }
              }
            },
            error: (error) => {
              this.loadFlag2 = false;
              this.service.showSnackBar(error.message, 'ok', 3000);
            },
          });
      }
    } else {
      this.loadFlag2 = false;
      this.dialogRef.close(true);
    }
  }
  cancel() {
    this.dialogRef.close(true);
  }
}
